var _path, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCoupon20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8H2.7C2.7 8.44183 3.05817 8.8 3.5 8.8V8ZM3.5 11V10.2C3.05817 10.2 2.7 10.5582 2.7 11H3.5ZM4.3 6C4.3 5.33726 4.83726 4.8 5.5 4.8V3.2C3.9536 3.2 2.7 4.4536 2.7 6H4.3ZM4.3 8V6H2.7V8H4.3ZM3.5 8.8C3.78697 8.8 4.10625 9.06398 4.10625 9.5H5.70625C5.70625 8.27916 4.76633 7.2 3.5 7.2V8.8ZM4.10625 9.5C4.10625 9.93602 3.78697 10.2 3.5 10.2V11.8C4.76633 11.8 5.70625 10.7208 5.70625 9.5H4.10625ZM4.3 13V11H2.7V13H4.3ZM5.5 14.2C4.83726 14.2 4.3 13.6627 4.3 13H2.7C2.7 14.5464 3.9536 15.8 5.5 15.8V14.2ZM15.5 14.2H5.5V15.8H15.5V14.2ZM16.7 13C16.7 13.6627 16.1627 14.2 15.5 14.2V15.8C17.0464 15.8 18.3 14.5464 18.3 13H16.7ZM16.7 6V13H18.3V6H16.7ZM15.5 4.8C16.1627 4.8 16.7 5.33726 16.7 6H18.3C18.3 4.4536 17.0464 3.2 15.5 3.2V4.8ZM5.5 4.8H15.5V3.2H5.5V4.8Z",
    fill: "#4C4C4C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.47651,
    y1: 4.8,
    x2: 8.47651,
    y2: 14.2,
    stroke: "#4C4C4C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoupon20);
export default __webpack_public_path__ + "static/media/ic_coupon_20.8ebe20427332e6be4f22d8f46232dbde.svg";
export { ForwardRef as ReactComponent };